import { type InsuranceCorporateIdentity } from "../types";

export function WirtschaftUndFinanzenLogo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M348.125 256.1C348.125 227.407 371.754 204.2 400.025 204.2C428.295 204.2 451.925 227.829 451.925 256.1C451.925 284.371 428.295 308 400.025 308C370.91 308 348.125 284.371 348.125 256.1Z"
        fill="#BCA45F"
      />
      <path
        d="M204.662 256.1C204.662 227.407 228.291 204.2 256.562 204.2C284.832 204.2 308.462 227.829 308.462 256.1C308.462 284.371 284.832 308 256.562 308C227.025 308 204.662 284.371 204.662 256.1Z"
        fill="#BCA45F"
      />
      <path
        d="M60.7759 256.1C60.7759 227.407 84.4051 204.2 112.676 204.2C140.947 204.2 164.576 227.829 164.576 256.1C164.576 284.371 140.947 308 112.676 308C84.4051 308 60.7759 284.371 60.7759 256.1Z"
        fill="#BCA45F"
      />
    </svg>
  );
}

export const WirtschaftUndFinanzen: InsuranceCorporateIdentity = {
  id: "wirtschaft-und-finanzen",
  name: "Wirtschaft und Finanzen",
  logo: WirtschaftUndFinanzenLogo,
  backgroundColor: "#1B335C",
  textColor: "#FFFFFF",
  wildcard: "wirtschaft",
  type: "statutory",
};
